/* @flow */
export type MediaType =
  | "application/vnd.nexia.collection+json"
  | "application/vnd.nexia.device+json"
  | "application/vnd.nexia.schema+json"
  | "application/vnd.nexia.automation+json"
  | "application/vnd.nexia.event+json"
  | "application/vnd.nexia.mode+json"
  | "application/vnd.nexia.video+json"
  | "application/vnd.nexia.location+json"
  | "application/vnd.nexia.user-code+json"
  | "application/vnd.nexia.alert+json"
  | "application/vnd.nexia.news+json"
  | "application/vnd.nexia.account+json"
  | "application/vnd.nexia.geofence+json"
  | "application/vnd.nexia.choice+json"
  | "application/vnd.nexia.phone+json";

export default {
  COLLECTION: "application/vnd.nexia.collection+json",
  DEVICE: "application/vnd.nexia.device+json",
  SCHEMA: "application/vnd.nexia.schema+json",
  AUTOMATION: "application/vnd.nexia.automation+json",
  EVENT: "application/vnd.nexia.event+json",
  MODE: "application/vnd.nexia.mode+json",
  VIDEO: "application/vnd.nexia.video+json",
  LOCATION: "application/vnd.nexia.location+json",
  USER_CODE: "application/vnd.nexia.user-code+json",
  ALERT: "application/vnd.nexia.alert+json",
  NEWS: "application/vnd.nexia.news+json",
  ACCOUNT: "application/vnd.nexia.account+json",
  GEOFENCE: "application/vnd.nexia.geofence+json",
  CHOICE: "application/vnd.nexia.choice+json",
  STREAM: "text/event-stream",
  PHONE: "application/vnd.nexia.phone+json",
};



// WEBPACK FOOTER //
// ./src/framework/media_type.js